import React from "react";
import "./_nftPlaceHolder.scss";

const NftPlaceHolder = ({ onMintClick, width }) => {
  return (
    <div className="placeholder-wrapper nft-caw-card" style={{ width: width }}>
      <a
        className="placeholder-button"
        href="https://ela.city/marketplace/collections/0xe27934fb3683872e35b8d9e57c30978e1260c614"
        target={"_blank"}
        rel="noreferrer"
      >
        <div className="placeholder-content">
          <img
            src={require("./landplaceholder.webp")}
            alt=""
            className="placeholder-content-img"
          />
          <p className="placeholder-content-text">
            You can view all your NFTs to manage them
          </p>
          <a
            className="placeholder-button"
            href="https://ela.city/marketplace/collections/0xe27934fb3683872e35b8d9e57c30978e1260c614"
            target={"_blank"}
            rel="noreferrer"
          >
            Buy on Marketplace
          </a>
        </div>
      </a>
    </div>
  );
};

export default NftPlaceHolder;
